import { convertDateToISO, fetchWrapper } from '@/_helpers';

export function getAggregate(team, startDate, endDate) {
    const params = new URLSearchParams();
    if (team) params.append('team', team);
    if (startDate) {
        params.append('startDate', convertDateToISO(startDate, { start: true }));
    }
    if (endDate) {
        params.append('endDate', convertDateToISO(endDate, { end: true }));
    }
    const qs = params.toString();
    return fetchWrapper.get(`staff-turnover/aggregate${qs ? '?' + qs : ''}`);
}

export function getStaff({ team, page, limit, sortBy, startDate, endDate } = {}) {
    const params = new URLSearchParams();
    if (team) params.append('team', team);
    if (page) params.append('page', page);
    if (limit) params.append('limit', limit);
    if (sortBy) params.append('sortBy', sortBy);
    if (startDate) {
        params.append('startDate', convertDateToISO(startDate, { start: true }));
    }
    if (endDate) {
        params.append('endDate', convertDateToISO(endDate, { end: true }));
    }
    const qs = params.toString();
    return fetchWrapper.get(`staff-turnover/staff${qs ? '?' + qs : ''}`);
}
